//import chunk from 'lodash/chunk'

import type {
  INewScheduleDetailsData,
  IScheduleSceneData,
  IScheduleSummaryDetailsData,
  IControllerSystemIdData,
} from '~~/store/definition';
import { useParamsStore } from '~~/store/local-storage/params';
import type { ComposerTranslation } from 'vue-i18n';

export default defineNuxtPlugin((nuxtApp: any) => {
  const app = nuxtApp.vueApp.$nuxt;

  const UtilTest = function (this: any) {
    console.log('app');
    console.log(app);
  };
  /**
   * Nullチェック
   * @param value
   * @returns true/false
   */
  const isNull = function (value: any) {
    return value === null || typeof value === 'undefined';
  };

  /**
   * 範囲チェック
   * @param  value
   * @param  Min 最小値
   * @param  Max 最大値
   * @returns true/false
   */
  const checkRange = function (value: number, min: number, max: number) {
    return min <= value && value <= max;
  };

  /**
   * projectIdチェック
   * @param projectId
   * @returns true/false
   */
  const checkProjectId = function (projectId: number) {
    if (!isNull(projectId) || !Number.isNaN(projectId)) {
      // 件名IDの範囲チェック[1~65535]
      if (checkRange(projectId, 1, 65535)) {
        return true;
      }
    }
    return false;
  };

  const getCreationStatusName = (n: number) => {
    const { $CREATION_STATUS } = useNuxtApp();
    switch (n) {
      case $CREATION_STATUS.BLANK:
        return 'blank';
      case $CREATION_STATUS.WAIT:
        return 'wait';
      case $CREATION_STATUS.SUCCESS:
        return 'success';
      case $CREATION_STATUS.NOW:
        return 'now';
      case $CREATION_STATUS.FAILED:
        return 'failed';
    }
    return '';
  };
  const getSendStatusName = (n: number) => {
    const { $SEND_STATUS } = useNuxtApp();
    switch (n) {
      case $SEND_STATUS.BLANK:
        return 'blank';
      case $SEND_STATUS.NOT:
        return 'not';
      case $SEND_STATUS.NOW:
        return 'now';
      case $SEND_STATUS.SUCCESS:
        return 'success';
      case $SEND_STATUS.FAILED:
      case $SEND_STATUS.FAILED_A2:
      case $SEND_STATUS.FAILED_INTERNAL:
        return 'failed';
      case $SEND_STATUS.DELETE:
        return 'delete';
    }
    return '';
  };
  const getSendKindStatusName = (n: number) => {
    const { $SCENE_KIND_STATUS } = useNuxtApp();
    switch (n) {
      case $SCENE_KIND_STATUS.BLANK:
        return 'blank';
      case $SCENE_KIND_STATUS.CW:
        return 'cw';
      case $SCENE_KIND_STATUS.CLOUD:
        return 'cloud';
      case $SCENE_KIND_STATUS.COMPOSITION:
        return 'composition';
    }
    return '';
  };

  const getControllerDivisionName = (n: number) => {
    const { $CONTROLLER_DIVISION } = useNuxtApp();
    switch (n) {
      case $CONTROLLER_DIVISION.PARENT:
        return 'parent';
      case $CONTROLLER_DIVISION.CHILD:
        return 'child';
      case $CONTROLLER_DIVISION.BACK_UP:
        return 'back_up';
    }
    return '';
  };

  const getTimeStringToTime = (time_str: string) => {
    if (!time_str) return 0;
    if (time_str == '' || time_str.indexOf(':') < 0) return 0;
    const [hours, minutes, seconds] = time_str.split(':');
    return Number(hours) * 60 * 60 + Number(minutes) * 60 + Number(seconds);
  };
  const getTimeToTimeString = (time: number) => {
    if (!time) return '00:00:00';
    time = Math.floor(time);
    const hour = Math.floor(time / (60 * 60));
    const minutes = Math.floor((time - hour * 60 * 60) / 60);
    const seconds = time - hour * 60 * 60 - minutes * 60;
    return [('0' + hour).slice(-2), ('0' + minutes).slice(-2), ('0' + seconds).slice(-2)].join(':');
  };
  /**
   * 時分秒を秒に変換する。
   * @param hour
   * @param min
   * @param sec
   */
  const getTimeToSeconds = (hour: number, min: number, sec: number) => {
    return hour * 60 * 60 + min * 60 + sec;
  };
  /**
   * 秒をhh:mm:ssに変換する。
   * @param sec
   */
  const getSecondsToTime = (seconds: number) => {
    const hour = Math.floor(seconds / 3600);
    const min = Math.floor((seconds % 3600) / 60);
    const sec = seconds % 60;
    let hh;
    // hour が3桁以上の場合は左0埋めをしない
    if (hour < 100) {
      hh = `00${hour}`.slice(-2);
    } else {
      hh = hour;
    }
    const mm = `00${min}`.slice(-2);
    const ss = `00${sec}`.slice(-2);

    return `${hh}:${mm}:${ss}`;
  };

  const getFormattedDate = (date: Date, format: string = 'yyyy/MM/dd hh:mm:ss') => {
    const symbol = {
      M: date.getMonth() + 1,
      d: date.getDate(),
      h: date.getHours(),
      m: date.getMinutes(),
      s: date.getSeconds(),
      S: date.getMilliseconds(),
    };

    let formatted = format.replace(/(M+|d+|h+|m+|s+)/g, (v) =>
      ((v.length > 1 ? '0' : '') + symbol[v.slice(-1) as keyof typeof symbol]).slice(-2)
    );

    formatted = formatted.replace(/(S+)/g, (v) =>
      ((v.length > 1 ? '00' : '') + symbol[v.slice(-1) as keyof typeof symbol]).slice(-3)
    );

    return formatted.replace(/(y+)/g, (v) => date.getFullYear().toString().slice(-v.length));
  };

  // 拡張子取得
  const getExtend = (path: string) => {
    // ドットが存在しない場合は空文字列を返す
    const lastDotIndex = path.lastIndexOf('.');
    if (lastDotIndex === -1 || lastDotIndex === path.length - 1) {
      return '';
    }
    // ドット以降の文字列を取得
    let result = path.substring(lastDotIndex + 1);
    // パラメータが存在する場合パラメータ部分の削除
    const len = result.indexOf('?');
    if (len > 0) {
      result = result.substring(0, result.indexOf('?'));
    }
    return result;
  };

  // 開始時間と終了時間を元に経過時間を算出する
  const calElapseTime = (startTime: string, endTime: string): string => {
    //引数が時間形式(hh:mm:ss)でない場合は計算しない
    if (!isFormatHHMMSS(startTime) || !isFormatHHMMSS(endTime)) return '';

    //経過時間算出のために一旦日付型に変換する
    //前提として同一日の時間入力同士の計算なのでDate化する際の日付は固定
    const wd = '2000/01/01';
    const startDate: Date = new Date(`${wd} ${startTime}`);
    const endDate: Date = new Date(`${wd} ${endTime}`);

    //開始時間 > 終了時間の場合、日を跨いでいるとして扱い、終了日に+1日する
    if (startDate > endDate) endDate.setDate(endDate.getDate() + 1);

    //終了日(終了時間) - 開始日(開始時間)を行い経過時間(ミリ秒)を算出
    const elapseMs: number = endDate.getTime() - startDate.getTime();

    //経過時間(ミリ秒)をhh:mm形式の文字列にして返却する
    return msToTimeString(elapseMs);
  };

  //文字列が時間形式(hh:mm:ss)かどうかを判定する
  const isFormatHHMMSS = (str: string): boolean => {
    const fmt = RegExp('^([0-1][0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])$');
    return fmt.test(str);
  };

  //ミリ秒から時分秒文字列(hh:mm:ss)を作成して返す
  const msToTimeString = (ms: number): string => {
    //1second = 1000ms
    //1minute = 60000ms
    //1hour = 60minutes = 3600000ms
    const hour = Math.floor(ms / 3600000);
    const minute = Math.floor((ms - 3600000 * hour) / 60000);
    const second = Math.floor((ms - 3600000 * hour - 60000 * minute) / 1000);
    const hh = ('00' + hour).slice(-2);
    const mm = ('00' + minute).slice(-2);
    const ss = ('00' + second).slice(-2);
    return `${hh}:${mm}:${ss}`;
  };
  /**
   * シーンデータから演出時間を取得
   * @param scenes
   */
  const getStagingTime = (
    scenes: Array<IScheduleSceneData>,
    baseTimeHour: number,
    baseTimeMinutes: number,
    t: ComposerTranslation
  ) => {
    const { $SUNSET_TIME, $SUNRISE_TIME } = useNuxtApp();

    // シーンが無ければ返却
    if (scenes.length === 0) return '--:--:-- ～ --:--:--';
    // 基準時刻を秒に変換する
    const baseTime = getTimeToSeconds(baseTimeHour, baseTimeMinutes, 0);
    // 日の入時刻を秒に変換する
    const baseSunsetTime = getTimeToSeconds(
      $SUNSET_TIME.HOURS,
      $SUNSET_TIME.MINUTES,
      $SUNSET_TIME.SECONDS
    );
    // 日の出時刻を秒に変換する
    const baseSunriseTime = getTimeToSeconds(
      $SUNRISE_TIME.HOURS,
      $SUNRISE_TIME.MINUTES,
      $SUNRISE_TIME.SECONDS
    );

    // 演出開始時間を取得
    const startStagingTime = getStartStagingTime(scenes, baseTime, baseSunsetTime, t);
    // 演出終了時間を取得
    const endStagingTime = getEndStagingTime(scenes, baseTime, baseSunriseTime, t);

    return startStagingTime + ' ～ ' + endStagingTime;
  };

  /**
   * 演出開始時間を取得
   */
  const getStartStagingTime = (
    scenes: Array<IScheduleSceneData>,
    baseTime: number,
    baseSunsetTime: number,
    t: ComposerTranslation
  ) => {
    const scenesData = scenes.slice().sort((x, y) => {
      // 演出時間を秒で求める
      let tmpStartTimeX = 0;
      let tmpStartTimeY = 0;
      if (x.isSpecifiedSunset) {
        // 日の入の場合
        if (x.isSpecifiedBeforeSunset) {
          // 日の入前が指定されていた場合
          tmpStartTimeX = baseSunsetTime - getTimeToSeconds(0, x.minutesBeforeOrAfterSunset, 0);
        } else {
          // 日の入後が指定されていた、または日の入前/後が設定されていない場合
          tmpStartTimeX = baseSunsetTime + getTimeToSeconds(0, x.minutesBeforeOrAfterSunset, 0);
        }
      } else {
        // 開始時刻から取得する場合
        tmpStartTimeX = getTimeToSeconds(x.startTimeHour, x.startTimeMinute, x.startTimeSecond);
      }
      if (y.isSpecifiedSunset) {
        // 日の入の場合
        if (y.isSpecifiedBeforeSunset) {
          // 日の入前が指定されていた場合
          tmpStartTimeY = baseSunsetTime - getTimeToSeconds(0, y.minutesBeforeOrAfterSunset, 0);
        } else {
          // 日の入後が指定されていた、または日の入前/後が設定されていない場合
          tmpStartTimeY = baseSunsetTime + getTimeToSeconds(0, y.minutesBeforeOrAfterSunset, 0);
        }
      } else {
        // 開始時刻から取得する場合
        tmpStartTimeY = getTimeToSeconds(y.startTimeHour, y.startTimeMinute, y.startTimeSecond);
      }

      // 0時から基準時刻の間の場合
      // 「24:00:00」を加算する。
      const startTimeX =
        tmpStartTimeX >= baseTime ? tmpStartTimeX : tmpStartTimeX + getTimeToSeconds(24, 0, 0);
      const startTimeY =
        tmpStartTimeY >= baseTime ? tmpStartTimeY : tmpStartTimeY + getTimeToSeconds(24, 0, 0);

      // 秒の昇順で並び変える
      if (startTimeX > startTimeY) return 1;
      if (startTimeX < startTimeY) return -1;

      return 0;
    });

    if (scenesData.length === 0) return '--:--:--';

    // 演出開始時間を設定
    const sceneData = scenesData[0];
    const startStagingTime = sceneData.isSpecifiedSunset
      ? t('schedule_manager_register.radio_sunset')
      : ('00' + sceneData.startTimeHour).slice(-2) +
        ':' +
        ('00' + sceneData.startTimeMinute).slice(-2) +
        ':' +
        ('00' + sceneData.startTimeSecond).slice(-2);

    return startStagingTime;
  };

  /**
   * 演出終了時間を取得
   */
  const getEndStagingTime = (
    scenes: Array<IScheduleSceneData>,
    baseTime: number,
    baseSunriseTime: number,
    t: ComposerTranslation
  ) => {
    const scenesData = scenes.slice().sort((x, y) => {
      // 演出時間を秒で求める
      let tmpEndTimeX = 0;
      let tmpEndTimeY = 0;
      if (x.isSpecifiedSunrise) {
        // 日の出の場合
        if (x.isSpecifiedBeforeSunrise) {
          // 日の出前が指定されていた場合
          tmpEndTimeX = baseSunriseTime - getTimeToSeconds(0, x.minutesBeforeOrAfterSunrise, 0);
        } else {
          // 日の出後が指定されていた、または日の入前/後が設定されていない場合
          tmpEndTimeX = baseSunriseTime + getTimeToSeconds(0, x.minutesBeforeOrAfterSunrise, 0);
        }
      } else {
        if (x.isSpecifiedEndTime || !x.isSpecifiedNormalSetting) {
          // 終了時刻から取得する場合
          tmpEndTimeX = getTimeToSeconds(x.endTimeHour, x.endTimeMinute, x.endTimeSecond);
        } else {
          // 終了時刻なしの場合
          if (baseTime == 0) {
            // 基準時刻が00:00の場合、終了時刻を23:59:59に設定する
            tmpEndTimeX = getTimeToSeconds(23, 59, 59);
          } else {
            tmpEndTimeX = baseTime - 1;
          }
        }
      }
      if (y.isSpecifiedSunrise) {
        // 日の出の場合
        if (y.isSpecifiedBeforeSunrise) {
          // 日の出前が指定されていた場合
          tmpEndTimeY = baseSunriseTime - getTimeToSeconds(0, y.minutesBeforeOrAfterSunrise, 0);
        } else {
          // 日の出後が指定されていた、または日の入前/後が設定されていない場合
          tmpEndTimeY = baseSunriseTime + getTimeToSeconds(0, y.minutesBeforeOrAfterSunrise, 0);
        }
      } else {
        if (y.isSpecifiedEndTime || !y.isSpecifiedNormalSetting) {
          // 終了時刻から取得する場合
          tmpEndTimeY = getTimeToSeconds(y.endTimeHour, y.endTimeMinute, y.endTimeSecond);
        } else {
          // 終了時刻なしの場合
          if (baseTime == 0) {
            // 基準時刻が00:00の場合、終了時刻を23:59:59に設定する
            tmpEndTimeY = getTimeToSeconds(23, 59, 59);
          } else {
            tmpEndTimeY = baseTime - 1;
          }
        }
      }

      // 0時から基準時刻の間の場合
      // 「24:00:00」を加算する。
      const endTimeX =
        tmpEndTimeX >= baseTime ? tmpEndTimeX : tmpEndTimeX + getTimeToSeconds(24, 0, 0);
      const endTimeY =
        tmpEndTimeY >= baseTime ? tmpEndTimeY : tmpEndTimeY + getTimeToSeconds(24, 0, 0);

      // 秒の昇順で並び変える
      if (endTimeX > endTimeY) return 1;
      if (endTimeX < endTimeY) return -1;

      return 0;
    });

    // シーンが無ければ返却
    if (scenes.length === 0) return '--:--:--';

    // 演出終了時間を設定
    const sceneData = scenesData[scenesData.length - 1];
    const endStagingTime = sceneData.isSpecifiedSunrise
      ? t('schedule_manager_register.radio_sunrise')
      : sceneData.isSpecifiedEndTime || !sceneData.isSpecifiedNormalSetting
      ? ('00' + sceneData.endTimeHour).slice(-2) +
        ':' +
        ('00' + sceneData.endTimeMinute).slice(-2) +
        ':' +
        ('00' + sceneData.endTimeSecond).slice(-2)
      : baseTime == 0
      ? getTimeToTimeString(getTimeToSeconds(23, 59, 59))
      : getTimeToTimeString(baseTime - 1);

    return endStagingTime;
  };

  /**
   * シーンの開始時刻を取得
   */
  const getSceneStartTime = (scene: IScheduleSceneData, t: ComposerTranslation) => {
    const _tmpStartTime =
      ('00' + scene.startTimeHour).slice(-2) +
      ':' +
      ('00' + scene.startTimeMinute).slice(-2) +
      ':' +
      ('00' + scene.startTimeSecond).slice(-2);
    return scene.isSpecifiedSunset ? t('schedule_manager_register.sunset') : _tmpStartTime;
  };
  /**
   * シーンの終了時刻を取得
   */
  const getSceneEndTime = (scene: IScheduleSceneData, t: ComposerTranslation) => {
    const _tmpEndTime =
      ('00' + scene.endTimeHour).slice(-2) +
      ':' +
      ('00' + scene.endTimeMinute).slice(-2) +
      ':' +
      ('00' + scene.endTimeSecond).slice(-2);
    return scene.isSpecifiedSunrise
      ? t('schedule_manager_register.sunrise')
      : scene.isSpecifiedEndTime || !scene.isSpecifiedNormalSetting
      ? _tmpEndTime
      : '--:--:--';
  };
  /**
   * 管理者権限有無の取得
   * true : あり(システム管理者 / システム運用担当 / エンジニアリング担当者 / 件名管理者)
   * false: なし(一般ユーザ)
   */
  const isSystem = () => {
    const params = useParamsStore();
    const role = params.systemRole;
    if (isNull(role)) return false;

    const { $SYSTEM_ROLE } = useNuxtApp();
    const isSystemRole = role !== $SYSTEM_ROLE.SYSTEM_ADMINISTRATOR;
    return isSystemRole;
  };

  /**
   * エンジニア権限有無の取得
   * true : あり(システム管理者 / システム運用担当 / エンジニアリング担当者 )
   * false: なし(一般ユーザ / 件名管理者)
   */
  const isEngineer = () => {
    const params = useParamsStore();
    const role = params.systemRole;
    if (isNull(role)) return false;

    const { $SYSTEM_ROLE } = useNuxtApp();
    const isEngineerRole =
      role === $SYSTEM_ROLE.ENGINEERING_MANAGER ||
      role === $SYSTEM_ROLE.SYSTEM_OPERATOR ||
      role === $SYSTEM_ROLE.SYSTEM_ADMINISTRATOR;
    return isEngineerRole;
  };

  /**
   * 件名管理者権限有無の取得
   * true : あり(システム管理者 / システム運用担当 / エンジニアリング担当者 / 件名管理者 )
   * false: なし(一般ユーザ)
   */
  const isSubjectManager = () => {
    const params = useParamsStore();
    const role = params.systemRole;
    if (isNull(role)) return false;

    const { $SYSTEM_ROLE } = useNuxtApp();
    const isSubjectManager =
      role === $SYSTEM_ROLE.SUBJECT_MANAGER ||
      role === $SYSTEM_ROLE.ENGINEERING_MANAGER ||
      role === $SYSTEM_ROLE.SYSTEM_OPERATOR ||
      role === $SYSTEM_ROLE.SYSTEM_ADMINISTRATOR;
    return isSubjectManager;
  };

  /**
   * 現在の環境名を取得
   */
  const getEnvName = () => {
    const { $ENV_NAME, $ENV_DOMAIN } = useNuxtApp();
    const uri = new URL(window.location.href);

    switch (uri.hostname) {
      case $ENV_DOMAIN.LOCAL:
        return $ENV_NAME.LOCAL;

      case $ENV_DOMAIN.DEV:
        return $ENV_NAME.DEV;

      case $ENV_DOMAIN.TEST:
        return $ENV_NAME.TEST;

      case $ENV_DOMAIN.STG:
        return $ENV_NAME.STG;

      case $ENV_DOMAIN.PROD:
        return $ENV_NAME.PROD;

      default:
        return $ENV_NAME.LOCAL;
    }
  };

  /**
   * APIのURLを取得
   */
  const getApiUrl = () => {
    const { $ENV_NAME, $API_URL } = useNuxtApp();
    const envName = getEnvName();

    switch (envName) {
      case $ENV_NAME.LOCAL:
        const uri = new URL(window.location.href);
        return uri.origin ? uri.origin : $API_URL.LOCAL;

      case $ENV_NAME.DEV:
        return $API_URL.DEV;

      case $ENV_NAME.TEST:
        return $API_URL.TEST;

      case $ENV_NAME.STG:
        return $API_URL.STG;

      case $ENV_NAME.PROD:
        return $API_URL.PROD;

      default:
        return $API_URL.LOCAL;
    }
  };

  /**
   * クラウド共通基盤APIのURLを取得
   */
  const getCloudCommonApiUrl = () => {
    const config = useRuntimeConfig();
    const { $ENV_NAME, $CLOUD_COMMON_API_URL } = useNuxtApp();
    let envName = getEnvName();
    if (envName === $ENV_NAME.LOCAL && config.public.appEnv) {
      envName = config.public.appEnv;
    }

    switch (envName) {
      case $ENV_NAME.LOCAL:
        const uri = new URL(window.location.href);
        return uri.origin ? uri.origin : $CLOUD_COMMON_API_URL.LOCAL;

      case $ENV_NAME.DEV:
        return $CLOUD_COMMON_API_URL.DEV;

      case $ENV_NAME.TEST:
        return $CLOUD_COMMON_API_URL.TEST;

      case $ENV_NAME.STG:
        return $CLOUD_COMMON_API_URL.STG;

      case $ENV_NAME.PROD:
        return $CLOUD_COMMON_API_URL.PROD;

      default:
        return $CLOUD_COMMON_API_URL.LOCAL;
    }
  };

  /**
   * UUIDの生成処理
   */
  const generateUUID = () => {
    return crypto.randomUUID();
  };

  /**
   * JWTのデコード処理
   */
  const decodeJwt = (token: string) => {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const encodeURI = encodeURIComponent(atob(base64));
    const decodeString = decodeURIComponent(encodeURI);
    return JSON.parse(decodeString);
  };

  /**
   * コントローラシステム毎のYOI-enで作成されたスケジュールを一つにまとめる
   */
  const summaryYOIenSchedules = (schedules: Array<INewScheduleDetailsData>) => {
    const displaySchedulesInfoDetail: Array<IScheduleSummaryDetailsData> = [];
    // 渡されたスケジュールデータをディープコピー
    const copySchedules: Array<INewScheduleDetailsData> = JSON.parse(JSON.stringify(schedules));
    copySchedules.forEach((schedule) => {
      const controllerSystemIds: IControllerSystemIdData[] = [];
      for (const controllerSystem of schedule.controllerSystems) {
        const controllerSystemIdData = {
          controllerSystemId: controllerSystem.controllerSystemId,
        } as IControllerSystemIdData;

        controllerSystemIds.push(controllerSystemIdData);
      }
      if (schedule.scheduleNo <= 1000) {
        // CWで作成されたスケジュールは表示用スケジュールに追加する
        displaySchedulesInfoDetail.push({
          scheduleName: schedule.scheduleName,
          scheduleNo: schedule.scheduleNo,
          updatedAt: schedule.updatedAt,
          scenes: schedule.controllerSystems[0].scenes,
          controllerSystemIds: controllerSystemIds,
        });
      } else {
        // YOI-enで作成されたスケジュールの場合全コントローラシステムのスケジュール分実施する
        schedule.controllerSystems.forEach((controllerSystem) => {
          const indexDetail = displaySchedulesInfoDetail.findIndex(
            (detail) => detail.scheduleNo == schedule.scheduleNo
          );
          if (indexDetail == -1) {
            // YOI-enで作成されたかつ既に追加されていないスケジュールの場合、表示用スケジュールに追加する
            displaySchedulesInfoDetail.push({
              scheduleName: schedule.scheduleName,
              scheduleNo: schedule.scheduleNo,
              updatedAt: schedule.updatedAt,
              scenes: schedule.controllerSystems[0].scenes,
              controllerSystemIds: controllerSystemIds,
            });
          } else {
            // YOI-enで作成されたかつ既に追加されているスケジュールの場合、既存のシーンとは別のシーンがあった場合のみシーンを追加する
            // スケジュール一覧表示用詳細データからシーン比較用データを作成する
            let compareDetailScenes = displaySchedulesInfoDetail[indexDetail].scenes.map(
              ({ sceneNo, sceneId, ...data }) => data
            );

            controllerSystem.scenes.forEach((controllerSystemScene) => {
              // コントローラシステム毎のスケジュールデータから、シーン比較用データを作成する
              const { sceneNo, sceneId, ...compareControllerSystemScenes } = controllerSystemScene;
              if (
                !compareDetailScenes.some(
                  (detailScene) =>
                    JSON.stringify(detailScene) == JSON.stringify(compareControllerSystemScenes)
                )
              ) {
                displaySchedulesInfoDetail[indexDetail].scenes.push(controllerSystemScene);
                // シーンが追加された場合、スケジュール一覧表示用詳細データからシーン比較用データを再作成する
                compareDetailScenes = displaySchedulesInfoDetail[indexDetail].scenes.map(
                  ({ sceneNo, sceneId, ...data }) => data
                );
              }
            });
          }
        });
      }
    });
    return displaySchedulesInfoDetail;
  };

  return {
    provide: {
      getTimeToTimeString: getTimeToTimeString,
      getTimeStringToTime: getTimeStringToTime,
      getTimeToSeconds: getTimeToSeconds,
      getSecondsToTime: getSecondsToTime,
      getExtend: getExtend,
      isNull: isNull,
      checkProjectId: checkProjectId,
      checkRange: checkRange,
      UtilTest: UtilTest,
      getCreationStatusName: getCreationStatusName,
      getSendStatusName: getSendStatusName,
      getSendKindStatusName: getSendKindStatusName,
      getControllerDivisionName: getControllerDivisionName,
      getFormattedDate: getFormattedDate,
      calElapseTime: calElapseTime,
      isFormatHHMMSS: isFormatHHMMSS,
      msToTimeString: msToTimeString,
      getStagingTime: getStagingTime,
      getStartStagingTime: getStartStagingTime,
      getEndStagingTime: getEndStagingTime,
      getSceneStartTime: getSceneStartTime,
      getSceneEndTime: getSceneEndTime,
      isSystem: isSystem,
      isEngineer: isEngineer,
      isSubjectManager: isSubjectManager,
      getEnvName: getEnvName,
      getApiUrl: getApiUrl,
      getCloudCommonApiUrl: getCloudCommonApiUrl,
      generateUUID: generateUUID,
      decodeJwt: decodeJwt,
      summaryYOIenSchedules: summaryYOIenSchedules,
    },
  };
});
